import { Checkbox } from "@progress/kendo-react-inputs";

export const DefaultDateTimeProperty = {
  propertyName: "DefaultValue",
  propertyDisplay: "Default to Now?",
  propertyType: "datetime",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name="DefaultValue"
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        value={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
